module.exports = __webpack_public_path__ + "static/img/9.bf6b8f9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/4/1/zh/9.png
// module id = Haaz
// module chunks = 0